import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import MasterDataTable from './MasterDataTable.vue';
import { buildInverterRows } from './inverterRows';
import { getMasterDataApi, importMasterDataApi } from '@/api/selfAnalysis';

/** 這幾欄由 02／05／06 算出來，其餘常填同值的欄位整批套 */
var DERIVED = ['site_code', 'inv_index', 'inv_id', 'actual_kwp', 'string_count', 'mppt_count'];
export default {
  name: 'InverterMasterPanel',
  components: {
    MasterDataTable: MasterDataTable
  },
  props: {
    def: {
      type: Object,
      required: true
    },
    siteCode: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      open: false,
      loading: false,
      saving: false,
      base: [],
      noDesign: false,
      existing: 0,
      spec: {},
      loadError: '',
      error: ''
    };
  },
  computed: {
    specColumns: function specColumns() {
      return this.def.columns.filter(function (c) {
        return c.sticky && !DERIVED.includes(c.name);
      });
    },
    rows: function rows() {
      var _this = this;
      return this.base.map(function (r) {
        return _objectSpread(_objectSpread(_objectSpread({}, r), _this.spec), {}, {
          parent_node_id: _this.spec.parent_node_id || r.parent_node_id
        });
      });
    },
    previewFields: function previewFields() {
      var _this2 = this;
      return ['inv_index', 'inv_id', 'parent_node_id', 'string_count', 'mppt_count', 'actual_kwp'].map(function (n) {
        return {
          key: n,
          label: _this2.def.columns.find(function (c) {
            return c.name === n;
          }).label
        };
      });
    }
  },
  methods: {
    onShow: function onShow() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var last, _yield$Promise$all, _yield$Promise$all2, topology, map, design, mine;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.error = '';
                _this3.loadError = '';
                _this3.base = [];
                _this3.existing = 0;
                // 表格裡最後一列的品牌型號先帶上，同一個案場通常整批同型號
                last = _this3.$refs.table.rows[_this3.$refs.table.rows.length - 1] || {};
                _this3.spec = Object.fromEntries(_this3.specColumns.map(function (c) {
                  var _last$c$name;
                  return [c.name, (_last$c$name = last[c.name]) !== null && _last$c$name !== void 0 ? _last$c$name : null];
                }));
                _this3.loading = true;
                _context.prev = 7;
                _context.next = 10;
                return Promise.all(['inverter_topology_nodes', 'mppt_string_map', 'string_design', 'inverter_master'].map(function (t) {
                  return getMasterDataApi(t, _this3.siteCode).then(function (res) {
                    return res.data || [];
                  });
                }));
              case 10:
                _yield$Promise$all = _context.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 4);
                topology = _yield$Promise$all2[0];
                map = _yield$Promise$all2[1];
                design = _yield$Promise$all2[2];
                mine = _yield$Promise$all2[3];
                _this3.base = buildInverterRows(_this3.siteCode, topology, map, design);
                _this3.noDesign = !design.length;
                _this3.existing = mine.length;
                _context.next = 24;
                break;
              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](7);
                _this3.loadError = (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.msg) || (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || '讀不到主檔 02／05／06';
              case 24:
                _context.prev = 24;
                _this3.loading = false;
                return _context.finish(24);
              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 21, 24, 27]]);
      }))();
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.saving = true;
                _this4.error = '';
                _context2.prev = 2;
                _context2.next = 5;
                return importMasterDataApi('inverter_master', _this4.rows);
              case 5:
                res = _context2.sent;
                _this4.$swal(res.msg || '已寫入');
                _this4.open = false;
                _this4.$refs.table.load();
                _this4.$emit('changed');
                _context2.next = 15;
                break;
              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](2);
                _this4.error = (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.msg) || (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || '寫入失敗';
              case 15:
                _context2.prev = 15;
                _this4.saving = false;
                return _context2.finish(15);
              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 12, 15, 18]]);
      }))();
    }
  }
};